import { Search } from "lucide-react"
import { useEffect, useState } from "react"
import type { User } from "../types"
import SearchModal from "./SearchModal"

type TopBarProps = {
  user: User | null
}

const TopBar = ({ user }: TopBarProps) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false)

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Cmd+K or Ctrl+K to open search
      if ((event.metaKey || event.ctrlKey) && event.key === "k") {
        event.preventDefault()
        setIsSearchOpen(true)
      }
    }

    window.addEventListener("keydown", handleKeyDown)
    return () => window.removeEventListener("keydown", handleKeyDown)
  }, [])

  return (
    <>
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <p className="text-xl sm:text-2xl font-semibold text-slate-900">
            Hello{user ? `, ${user.name.split(" ")[0]}` : ""}!
          </p>
          <p className="text-xs sm:text-sm text-stone">
            Explore information and activity about your agency operations.
          </p>
        </div>
        <div className="flex flex-1 items-center justify-end gap-2 sm:gap-3">
          <button
            type="button"
            onClick={() => setIsSearchOpen(true)}
            className="relative flex w-full max-w-md items-center gap-2 rounded-full border border-line bg-white px-4 py-2 text-left shadow-soft transition hover:border-slate-300"
          >
            <Search className="h-4 w-4 text-stone" />
            <span className="flex-1 text-sm text-stone">Search clients, projects, invoices...</span>
            <kbd className="hidden rounded border border-line bg-slate-50 px-2 py-0.5 text-xs font-mono text-stone sm:inline">
              ⌘K
            </kbd>
          </button>
        </div>
      </div>
      <SearchModal isOpen={isSearchOpen} onClose={() => setIsSearchOpen(false)} />
    </>
  )
}

export default TopBar
